export const tech_ai = [
  { char: '🤖', name: 'Robot', nameZh: 'AI角色/機器人', keywords: ['ai', 'chatgpt', 'bot'], hot: true },
  { char: '🧠', name: 'Brain', nameZh: '類神經網絡', keywords: ['ai', 'smart', 'algorithm'] },
  { char: '💻', name: 'Laptop', nameZh: '程式開發', keywords: ['code', 'dev', 'software'] },
  { char: '💻', name: 'Laptop', nameZh: '雲端運算', keywords: ['cloud', 'saas', 'server'] },
  { char: '⚙️', name: 'Gear', nameZh: '系統設定', keywords: ['setting', 'engine', 'core'] },
  { char: '🛡️', name: 'Shield', nameZh: '資訊安全', keywords: ['cyber', 'security', 'hack'] },
  { char: '📂', name: 'Folder', nameZh: '資料庫', keywords: ['data', 'sql', 'storage'] },
  { char: '⚡', name: 'Voltage', nameZh: '高效能', keywords: ['fast', 'performance', 'power'] },
  { char: '🔗', name: 'Link', nameZh: 'API連結', keywords: ['connect', 'api', 'url'] },
  { char: '⌨️', name: 'Keyboard', nameZh: '終端機指令', keywords: ['type', 'cli', 'linux'] },
  { char: '⚛️', name: 'Atom', nameZh: '深度學習/核心', keywords: ['science', 'core', 'react'] },
  { char: '🔋', name: 'Battery', nameZh: '穩定續航', keywords: ['power', 'long', 'stable'] },
];